import React from 'react';

import { SkeletonButton } from '@xingternal/skeleton';

import * as S from './results-skeleton.styles';

type Props = {
  hideButtons?: boolean;
};

export const ResultsSkeleton: React.VFC<Props> = ({ hideButtons = false }) => {
  return (
    <>
      <S.Header>
        <S.SkeletonHeadline amountRows={1} size="medium" />
        {hideButtons ? null : (
          <S.Buttons>
            <SkeletonButton size="small" />
            <S.SkeletonButton size="small" />
          </S.Buttons>
        )}
      </S.Header>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <S.ResultItemSkeleton key={index} />
        ))}
    </>
  );
};
